import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { Search } from '@material-ui/icons'
import { Divider, TextField, Button, Grid, Select, MenuItem, FormControl, InputLabel, InputAdornment } from '@material-ui/core'
import { RISKMGT, API } from '@const'
import * as utils from '@utils'
import ManualPrizeListDialog from '@risk/manual-prize-list-dialog'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
import { PfSubPfSelect, DateSelect } from '@select'
import Table from '@tables/table'

class ManualPrizePage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'ManualPrizePage')
        }
    }

    state = {
        pfSubPfId: 'all',
        totalLossPrize: 100000,
        rtp: 85,
        totalBet: 500000,
        isLoading: false,
        searchType: 'condition',
    }

    columns = [
        {
            field: 'pf_sub_pf_id',
            type: 'platform',
        },
        {
            field: 'pf_account',
        },
        {
            field: 'player_name',
        },
        {
            field: 'accumulated_prize',
            type: 'currency',
        },
        {
            field: 'rtp_value',
            type: 'percentage',
        },
        {
            field: 'accumulated_bet',
            type: 'currency',
        },
        {
            field: 'risk_role_translated',
            translate: {
                dataKey: 'risk_role',
                tranKey: 'RiskRole',
            },
        },
        {
            field: 'set_prize',
            render: (rowData) => {
                return (
                    <Button
                        style={{ minWidth: '93px' }}
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        onClick={() => {
                            this.detailDialog.OpenDialog({ pf_account: rowData.pf_account })
                        }}>
                        {this.t('prizing')}
                    </Button>
                )
            },
        },
    ]

    queryData() {
        this.table.SetLoading(true)

        let queryParams

        if (this.state.searchType === 'condition')
            queryParams = {
                pf_id: this.pfSelect.state.pfId !== 'all'? this.pfSelect.state.pfId : '',
                pf_sub_pf_id: this.pfSelect.state.pfSubPfId !== 'all' ? this.pfSelect.state.pfSubPfId : '',
                during: [utils.datetimeToUnix(this.dateSelect.state.startDate), utils.datetimeToUnix(this.dateSelect.state.endDate)].join(','),
                rtp_range: [-RISKMGT.MAX_FLOAT, this.state.rtp].join(','),
                bet_range: [this.state.totalBet, RISKMGT.MAX_FLOAT].join(','),
                prize_range: [-RISKMGT.MAX_FLOAT, -this.state.totalLossPrize].join(','),
            }
        else
            queryParams = {
                pf_account: this.state.pfAccount,
            }

        utils.apiRequest(
            'get',
            API.RISKMGT_PLAYER_RISK_INFO_LIST,
            queryParams,
            (data) => {
                const tempList = []
                for (const idx in data) {
                    var temp = utils.deepCopy(data[idx])

                    tempList.push(temp)
                }

                this.table.SetData(tempList)
                this.setState({ isLoading: false })
            },
            (_err) => {
                this.table.SetData([])
                this.setState({ isLoading: false })
            },
            true
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl className={this.props.classes.formControl}>
                        <InputLabel htmlFor="age-simple">{this.t('searchType')}</InputLabel>
                        <Select
                            value={this.state.searchType}
                            onChange={(event) =>
                                this.setState({
                                    searchType: event.target.value,
                                })
                            }>
                            <MenuItem value="condition">{this.t('condition')}</MenuItem>
                            <MenuItem value="account">{this.t('account')}</MenuItem>
                        </Select>
                    </FormControl>
                    {this.state.searchType === 'condition' ? (
                        <React.Fragment>
                            <PfSubPfSelect
                                onRef={(ref) => (this.pfSelect = ref)}
                                options={{
                                    hideCurrency: true,
                                }}></PfSubPfSelect>
                            <DateSelect onRef={(ref) => (this.dateSelect = ref)}></DateSelect>
                            <TextField
                                label={this.t('totalLossPrize')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.totalLossPrize}
                                onChange={(event) =>
                                    this.setState({
                                        totalLossPrize: event.target.value,
                                    })
                                }
                                className={this.props.classes.textField}
                            />
                            <TextField
                                label={this.t('rtpLower')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.rtp}
                                onChange={(event) =>
                                    this.setState({
                                        rtp: event.target.value,
                                    })
                                }
                                className={this.props.classes.textField}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                            />
                            <TextField
                                label={this.t('totalBet')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.totalBet}
                                onChange={(event) =>
                                    this.setState({
                                        totalBet: event.target.value,
                                    })
                                }
                                className={this.props.classes.textField}
                            />
                        </React.Fragment>
                    ) : (
                        <TextField
                            label={this.t('account')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={this.state.pfAccount}
                            onChange={(event) =>
                                this.setState({
                                    pfAccount: event.target.value,
                                })
                            }
                            className={this.props.classes.textField}
                        />
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        onClick={() => {
                            this.setState({ isLoading: true })
                            this.queryData()
                        }}
                        disabled={this.state.isLoading}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        onClick={() => this.detailDialog.OpenDialog({ from: 'ManualPrizePage' })}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('manualPrizeRecord')}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Table
                        ownerName="ManualPrizePage"
                        columns={this.columns}
                        options={{ export: true, orderIdx: 1 }}
                        onRef={(ref) => (this.table = ref)}
                    />
                    <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
                </Grid>
                <ManualPrizeListDialog onRef={(ref) => (this.detailDialog = ref)} />
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        textField: {
            margin: theme.spacing(1),
            width: '150px',
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
    }
}

ManualPrizePage.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default hoc(styles)(ManualPrizePage)
